export interface Bonus {
  number: number
  title: string
  description: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The 5-Minute Ballet Class Planner',
    description: 'Design professional classes in minutes—not hours.',
    image:
      'https://cdn.magicpatterns.com/uploads/ngzCLStwq6eGeZPaRiyLfW/bo1.webp',
    alt: 'Bonus 1 cover: The 5-Minute Class Planner',
  },
  {
    number: 2,
    title: 'Mixed-Level Adaptation Kit',
    description: 'Teach groups with different abilities without chaos.',
    image:
      'https://cdn.magicpatterns.com/uploads/rdMwJUYtEg89yRRQX4ypvL/bo2.webp',
    alt: 'Bonus 2 cover: Mixed-Level Adaptation Kit',
  },
  {
    number: 3,
    title: 'Age-by-Age Teaching Map',
    description: 'What to teach (and what not to) for ages 3–16.',
    image:
      'https://cdn.magicpatterns.com/uploads/8Mn3eSVSh8BaUuPEyzUXvy/bo3.webp',
    alt: 'Bonus 3 cover: Age-by-Age Teaching Map',
  },
  {
    number: 4,
    title: 'Ballet Music & Counts Cheat Sheet',
    description: 'Perfect tempos, rhythms, and counts for every exercise.',
    image:
      'https://cdn.magicpatterns.com/uploads/3qBzRULUSAcg1MuMdtMW5G/bo4.webp',
    alt: 'Bonus 4 cover: Music & Counts Cheat Sheet',
  },
  {
    number: 5,
    title: 'Emergency Class Pack',
    description: '5 complete classes ready to print and teach.',
    image:
      'https://cdn.magicpatterns.com/uploads/eYoTouAMCbAmxDBUuD6g5C/bo5.webp',
    alt: 'Bonus 5 cover: Emergency Class Pack',
  },
  {
    number: 6,
    title: '30 Themed Classes for Kids',
    description: 'Imagination + technique = kids who love ballet.',
    image:
      'https://cdn.magicpatterns.com/uploads/q3C5KpJTqs9MWen2dnKwCP/bo6.webp',
    alt: 'Bonus 6 cover: 30 Themed Classes for Kids',
  },
  {
    number: 7,
    title: 'Quick-Start Printables Vault',
    description: '20+ trackers, planners, and reference sheets.',
    image:
      'https://cdn.magicpatterns.com/uploads/cHLXt4Czx3KtSMs5LABaX3/bo7.webp',
    alt: 'Bonus 7 cover: Quick-Start Printables Vault',
  },
]
